import React from "react";

const Simple = ({ label, credit, styles }) => (
  <tr>
    {/*<td width="15%" style={styles.centerCell}></td>*/}
    <td width="85%" style={styles.cell}>
      {label}
    </td>
    <td width="15%" style={styles.amountCell}>
      {credit}
    </td>
  </tr>
);

export default Simple;
